import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProfessionalWizard } from 'src/app/shared/models/professional-wizard.model';

@Component({
    selector: 'app-professional-item',
    templateUrl: './professional-item.component.html',
    styleUrls: ['./professional-item.component.scss'],
})
export class ProfessionalItemComponent implements OnInit {
    @Input() professional: ProfessionalWizard;
    @Input() avatarBackground = 'E9F5FF';
    @Input() avatarColor = '255190';
    /** Flowwwer template */
    @Input() avatarName;
    @Input() professionalChecked: boolean;

    @Output() professionalClickedEvent = new EventEmitter<ProfessionalWizard>();

    constructor() {}

    ngOnInit(): void {}

    onProfessionalClicked(professional: ProfessionalWizard) {
        this.professionalClickedEvent.emit(professional);
    }

    /** Flowwwer template */
    onProfessionalChecked(event: Event) {
        event.preventDefault();
    }

    get professionalImage() {
        return `https://eu.ui-avatars.com/api/?name=${encodeURIComponent(
            this.avatarName ? this.avatarName : this.professional.description
        )}&background=${this.avatarBackground}&color=${
            this.avatarColor
        }&rounded=true&bold=true`;
    }
}
